import { IEta } from "../../contractors/engineers/IEta";
import { IAllocation } from "./IAllocation";

export interface IAppointment {
    id: string,
    created: string,
    created_by_id: string,
    status: AppointmentStatus,
    job_number: string,
    date: string,
    start_date: string,
    end_date: string,
    type?: number| null,
    chased: boolean | null,
    notes: string | null,
    required_warning_time: number,
    eta: IEta | null,
    allocation: IAllocation | null,
    suggested_engineer_id?: string | null,
    version: string
}

export enum AppointmentStatus { Failed = -100, Tentative = -1, Pending = 0, Completed = 100 }